"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { wrapper } from './styles.js';
import { ThemeProvider } from 'styled-components';
import { DatePickerLazy } from './DatePickerLazy.web.js';
import { useTheme } from '../utils/theming/useTheme.js';

var _excluded = ["className", "style", "errorMessage", "error", "label", "name", "value", "dateFormat", "locale", "borderStyle", "labelStyle", "color"];
var DatePickerSsr = function DatePickerSsr(_ref) {
  var className = _ref.className,
    style = _ref.style,
    errorMessage = _ref.errorMessage,
    error = _ref.error,
    label = _ref.label,
    name = _ref.name,
    value = _ref.value,
    _ref$dateFormat = _ref.dateFormat,
    dateFormat = _ref$dateFormat === undefined ? 'dd.MM.yyyy' : _ref$dateFormat,
    _ref$locale = _ref.locale,
    locale = _ref$locale === undefined ? 'fi' : _ref$locale,
    borderStyle = _ref.borderStyle;
    _ref.labelStyle;
    var colorProp = _ref.color,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var color = colorProp || theme.inputField.web.color;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(wrapper, {
    "data-test": "elemental-DatePickerSsr",
    className: className,
    $color: color,
    style: style
  }, /*#__PURE__*/React.createElement(DatePickerLazy, _extends({
    errorMessage: errorMessage,
    error: error,
    label: label,
    name: name,
    value: value,
    dateFormat: dateFormat,
    locale: locale,
    color: color,
    borderStyle: borderStyle || theme.inputField.web.borderStyle
  }, props))));
};

export { DatePickerSsr };
